import { truncateText } from 'utils/text';
import { ContentTypeCategory, getCategories } from 'components/Page/Toolbox/utils';

const mapBookmarkData = (data, type, url) => ({
  title: truncateText(
    data.title || data.webinarTitle || data.podcastTitle || data.contentOfferTitle,
    75
  ),
  image:
    data?.image?.file?.url ||
    data?.image ||
    data?.assetThumbnail?.file?.url ||
    data?.featuredImage?.file?.url ||
    data?.featuredImage?.image?.file?.url ||
    data?.cardPhoto?.image?.file?.url ||
    data?.cover?.file?.url,
  subTitle: data?.subTitle || getCategories(data),
  url: url || data?.ctaLink || data?.seo?.pageUrl || data?.seoData?.pageUrl || data?.slug,
  type: (type || data.type || ContentTypeCategory[data.__typename])?.toLowerCase(),
});

export default mapBookmarkData;
